import { render, staticRenderFns } from "./VPhotoInput.vue?vue&type=template&id=26a80886"
import script from "./VPhotoInput.vue?vue&type=script&lang=js"
export * from "./VPhotoInput.vue?vue&type=script&lang=js"
import style0 from "./VPhotoInput.vue?vue&type=style&index=0&id=26a80886&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports